/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC to Regex Converter`)
};

const es_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC a Regex`)
};

const de_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-zu-Regex-Konverter`)
};

const nl_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-naar-regexconverter`)
};

const fr_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur IUPAC vers Regex`)
};

const it_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore da IUPAC a espressione regolare`)
};

const pt_br2_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC para Regex`)
};

const pt_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de IUPAC para Regex`)
};

const ja_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC→正規表現変換ツール`)
};

const zh_iupac_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC 转正则表达式转换器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_h1", locale)
	if (locale === "en") return en_iupac_h1(inputs)
	if (locale === "es") return es_iupac_h1(inputs)
	if (locale === "de") return de_iupac_h1(inputs)
	if (locale === "nl") return nl_iupac_h1(inputs)
	if (locale === "fr") return fr_iupac_h1(inputs)
	if (locale === "it") return it_iupac_h1(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_h1(inputs)
	if (locale === "pt") return pt_iupac_h1(inputs)
	if (locale === "ja") return ja_iupac_h1(inputs)
	return zh_iupac_h1(inputs)
};